module.exports = __webpack_public_path__ + "img/Image -5.ce118760.png";